module.exports = __webpack_public_path__ + "img/CM-PW-25-Kia-Established.148134ed.jpg";